"use strict";
/*
 * Copyright 2020 - MATTR Limited
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *     http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveProof = exports.BbsBlsSignatureProof2020 = exports.BbsBlsSignature2020 = exports.Bls12381G2KeyPair = void 0;
var bls12381_key_pair_1 = require("@mattrglobal/bls12381-key-pair");
Object.defineProperty(exports, "Bls12381G2KeyPair", { enumerable: true, get: function () { return bls12381_key_pair_1.Bls12381G2KeyPair; } });
var BbsBlsSignature2020_1 = require("./BbsBlsSignature2020");
Object.defineProperty(exports, "BbsBlsSignature2020", { enumerable: true, get: function () { return BbsBlsSignature2020_1.BbsBlsSignature2020; } });
var BbsBlsSignatureProof2020_1 = require("./BbsBlsSignatureProof2020");
Object.defineProperty(exports, "BbsBlsSignatureProof2020", { enumerable: true, get: function () { return BbsBlsSignatureProof2020_1.BbsBlsSignatureProof2020; } });
__exportStar(require("./types"), exports);
var deriveProof_1 = require("./deriveProof");
Object.defineProperty(exports, "deriveProof", { enumerable: true, get: function () { return deriveProof_1.deriveProof; } });
//# sourceMappingURL=index.js.map